<template>
  <div>
    <button
      :class="[tabActive == id?'tab-active':'tab-inactive']"
      class="tab-btns border-0 btn-outline-none  bg-white text-medium-gray fs-12 py-9 px-32 position-relative text-center w-100"
      @click="handleTabClick(id)">{{ title }}</button>
  </div>
</template>
<script>
import EventBus from '@/EventBus';

export default {
  name:  'Tab',
  props: {
    title:     String,
    id:        [String, Number],
    tabActive: [String, Number],
  },
  data() {
    return {
      isTabClicked: false,
    };
  },
  methods: {
    handleTabClick(id) {
      EventBus.$emit('toggleTabs', id);
    },
  },
};

</script>
<style lang="scss">
  .tabs-inner {
    .tab-btns {
      font-weight: 600;
      line-height: 20px;
      font-size: 17px !important;
      padding-top: 15px !important;
      padding-bottom: 15px !important;
      width: 144px;
      max-width: 100%;

      &:after {
        content: "";
        height: 1px;
        width: 100%;
        transform: scaleX(0);
        transform-origin: center;
        bottom: 0;
        left: 0;
        position: absolute;
        background: $blue50;
        transition: ease all 0.3s;
      }
    }
  }
  .tab-active.tab-btns{
    color: $grey90 !important;
    &:after {
      transform: ScaleX(1);
      height: 1px;
      transition: ease all 0.3s;
      transform-origin: center;
    }
  }
  .tab-inactive{
    background: $white;

    &:after{
      right: 0;
      left: auto;
    }

  }

</style>
